/**
 * Mount path of the SPA in the browser.
 * Production images are built with a placeholder; the container entrypoint rewrites it
 * from UI_PUBLIC_PATH at start. "/" (or empty) means the host root.
 */

/** React Router basename. Undefined when the app is served at the host root. */
export function routerBasename(baseUrl: string | undefined): string | undefined {
  const raw = (baseUrl ?? "/").trim();
  if (raw === "" || raw === "/") return undefined;
  const withLead = raw.startsWith("/") ? raw : `/${raw}`;
  const trimmed = withLead.replace(/\/+$/, "");
  return trimmed === "" ? undefined : trimmed;
}

/** Absolute URL path on this deployment, including the configured mount path. */
export function appPath(suffix: string): string {
  const base = (import.meta.env.BASE_URL || "/").replace(/\/+$/, "");
  const path = suffix.startsWith("/") ? suffix : `/${suffix}`;
  if (base === "" || base === "/") return path;
  return `${base}${path}`;
}
